module.exports = __webpack_public_path__ + "img/success.7ac61b2a.svg";